import { formatLabel } from "@/lib/formats";

/* "FLAC · 24-bit / 96 kHz" style pill for Now Playing; notes when the server is feeding a converted copy. */
export const FormatBadge = ({ track, transcoding }) => {
  const f = formatLabel(track);
  if (!f) return null;
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="now-playing-format">
      <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.16em] ${f.protected ? "border-rose-400/50 text-rose-300" : f.lossless ? "border-amber-300/40 text-amber-200" : "border-white/15 text-zinc-300"}`}
        data-testid="now-playing-format-name">
        {f.name}{f.detail && <span className="font-normal normal-case tracking-normal text-zinc-400">· {f.detail}</span>}
      </span>
      {f.protected && (
        <span className="rounded-full bg-rose-500/15 px-2.5 py-0.5 text-[10px] font-medium text-rose-200" data-testid="now-playing-protected" title="Audible / iTunes copy protection can't be removed here, so this file can't be played or transcribed.">
          copy-protected · can't play
        </span>
      )}
      {transcoding && (
        <span className="rounded-full bg-white/10 px-2.5 py-0.5 text-[10px] font-medium text-zinc-300" data-testid="now-playing-transcoded" title="Your browser can't decode this format natively, so the server is streaming a converted copy.">
          converted for this browser
        </span>
      )}
    </div>
  );
};
